import React from "react";

function GithubIcon(props) {
    const handleClick = () => {
        window.open("https://github.com/prosaiful37")
    }
  return (
    <div>
      <a onClick={handleClick} href="">
        {" "}
        <i class="text-4xl text-white rounded-full hover:text-primary fa-brands fa-github-square"></i>{" "}
      </a>
    </div>
  );
}

export default GithubIcon;
